// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Conversație',
  working: 'Se gândește…',
  stopped: 'Oprit. Nimic nu s-a schimbat.',
  step_stopped: 'Oprit',
  steps_completed_one: '{{count}} pas finalizat',
  steps_completed_few: '{{count}} pași finalizați',
  steps_completed_other: '{{count}} pași finalizați',
  chart: {
    table: 'Valorile din acest grafic',
    label: 'Etichetă',
    value: 'Valoare',
  },
  // A form of several values Amigo needs at once (ask_form, contracts §5).
  form: {
    submit: 'Continuă',
    skip: 'Omite deocamdată',
    required: 'Completează pentru a continua',
    generated: 'Creat pentru tine la aprobare',
    step_of: 'Pasul {{index}} din {{total}}',
    on: 'Activat',
    off: 'Dezactivat',
    skipped: 'Omis deocamdată',
  },
  next_steps: 'Pașii următori',
  action_card: {
    select_restaurant: 'Selectează acest restaurant',
    open_page: 'Se deschide în dashboard',
  },
  not_sent: 'Netrimis',
  failed: {
    text: 'Ceva nu a mers bine din partea mea, așa că nimic nu s-a schimbat. Încearcă din nou peste un moment.',
    retry: 'Încearcă din nou',
  },
  question: {
    other: 'Altceva…',
    send: 'Trimite',
    label: 'Întrebare',
    type_answer: 'Altceva? Scrie mai jos.',
    label_many: 'Întrebări',
    step_of: '{{index}} din {{total}}',
    previous: 'Întrebarea anterioară',
    next: 'Întrebarea următoare',
    dismiss: 'Nu acum',
  },
  unavailable: {
    title: {
      amigo: 'Amigo nu este disponibil momentan.',
      assistant: 'Asistentul nu este disponibil momentan.',
    },
    text: 'Nimic nu s-a schimbat, iar restul panoului funcționează normal. Încearcă din nou în câteva minute.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Azi',
  when: {
    today: 'Azi, {{time}}',
    yesterday: 'Ieri, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line:
    'Conversație nouă pentru {{restaurant}}. Conversațiile lui {{previous}} se află la Conversații când te întorci la el.',
  // A restaurant selected during a chat with no restaurant selected (D18): the chat carries on there, or a new one starts.
  carried_on_line: 'Acum în {{restaurant}}. Acest chat continuă și este salvat împreună cu chaturile sale.',
  from_none_line:
    'Chat nou pentru {{restaurant}}. Chatul tău despre {{earlier}} se află la Chaturi, fără un restaurant selectat.',
  from_none_line_unnamed:
    'Chat nou pentru {{restaurant}}. Chatul tău anterior se află la Chaturi, fără un restaurant selectat.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: 'Chatul lui {{name}} (FoodAmigos)',
      owner: 'Chatul lui {{name}} (proprietar)',
      staff: 'Chatul lui {{name}} (personal)',
      partner: 'Chatul lui {{name}} (partener)',
      other: 'Chatul lui {{name}}',
      unnamed: 'Chatul altcuiva',
    },
    text: 'Conversația lui {{name}}. O poți citi, dar nu poți răspunde și nici aproba cardurile ei.',
    text_unnamed: 'Chatul altcuiva. Îl poți citi, dar nu poți răspunde și nici aproba cardurile lui.',
    new_chat: 'Conversație nouă',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Această conversație s-a încheiat. Începe o conversație nouă pentru a continua.',
    new_chat: 'Conversație nouă',
    moved_line: 'Chat nou, deoarece cel anterior se încheiase',
  },
  composer: {
    label: 'Mesaj',
    placeholder: 'Pune o întrebare sau descrie o modificare',
    placeholder_answer: 'Introduceți răspunsul',
    hint: 'Enter pentru a trimite · Shift+Enter rând nou',
  },
  table: {
    show_all: 'Afișează toate cele {{count}} rânduri',
    show_fewer: 'Afișează mai puține',
  },
  steps: {
    areas: 'Verific cu ce te pot ajuta aici',
    area_describe: 'Mă uit la {{area}}',
    restaurants: 'Se caută restaurantul',
    read: 'Citesc datele tale',
    propose: 'Pregătesc modificarea',
    change_set_get: 'Verific modificarea',
    change_set_undo: 'Se pregătește anularea',
    change_set_withdraw: 'Se închide cardul',
    gap_record: 'Notez asta pentru echipa noastră',
    research: 'Caut cum funcționează',
    screen_find: 'Caut pagina potrivită',
    file_read: 'Citesc fișierul tău',
    attach_chat_file: 'Se pregătește fișierul',
    shop_check: 'Verific magazinul tău',
    area_describe_other: 'Mă uit la această zonă',
    other: 'Verific ceva',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    restaurants: {
      other: 'Nu am găsit restaurantul',
    },
    read: {
      menu: 'Meniul nu a putut fi citit',
      hours: 'Programul de funcționare nu a putut fi citit',
      order_settings: 'Setările comenzilor nu au putut fi citite',
      my_info: 'Datele tale nu au putut fi citite',
      marketing: 'Marketingul tău nu a putut fi citit',
      gift_cards: 'Cardurile cadou nu au putut fi citite',
      reports: 'Cifrele tale nu au putut fi citite',
      other: 'Datele tale nu au putut fi citite',
    },
    propose: {
      menu: 'Modificarea meniului nu a putut fi pregătită',
      hours: 'Modificarea programului de funcționare nu a putut fi pregătită',
      order_settings: 'Modificarea setărilor comenzilor nu a putut fi pregătită',
      my_info: 'Modificarea datelor tale nu a putut fi pregătită',
      marketing: 'Modificarea de marketing nu a putut fi pregătită',
      gift_cards: 'Modificarea cardurilor cadou nu a putut fi pregătită',
      other: 'Modificarea nu a putut fi pregătită',
    },
    change_set_get: { other: 'Modificarea nu a putut fi verificată' },
    change_set_undo: { other: 'Nu s-a putut pregăti anularea' },
    change_set_withdraw: { other: 'Nu s-a putut închide cardul' },
    research: { other: 'Nu am putut afla cum funcționează aceasta' },
    screen_find: { other: 'Pagina nu a putut fi găsită' },
    file_read: { other: 'Fișierul tău nu a putut fi citit' },
    attach_chat_file: { other: 'Nu am putut pregăti fișierul' },
    shop_check: { other: 'Magazinul tău nu a putut fi deschis' },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'meniul',
    hours: 'programul de funcționare',
    order_settings: 'setările comenzilor',
    my_info: 'informațiile restaurantului tău',
    marketing: 'marketing',
    reports: 'rapoartele',
  },
};
